import useLanguageSync from "@/hooks/useLanguageSync";

/** Mounts inside <BrowserRouter> to sync URL ↔ i18next language and auto-redirect French browsers. */
export default function LanguageSyncRouter() {
  useLanguageSync();
  return null;
}
